import React from "react";

// Professional line icons (Lucide-style). Stroke = currentColor, round caps.
const base = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
};

export const IconScissors = (p) => (
    <svg {...base} {...p}>
        <circle cx="6" cy="6" r="3" />
        <circle cx="6" cy="18" r="3" />
        <line x1="20" y1="4" x2="8.12" y2="15.88" />
        <line x1="14.47" y1="14.48" x2="20" y2="20" />
        <line x1="8.12" y1="8.12" x2="12" y2="12" />
    </svg>
);

export const IconStar = (p) => (
    <svg {...base} {...p}>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
);

export const IconClock = (p) => (
    <svg {...base} {...p}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </svg>
);

export const IconImage = (p) => (
    <svg {...base} {...p}>
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <polyline points="21 15 16 10 5 21" />
    </svg>
);

export const IconArrowLeft = (p) => (
    <svg {...base} {...p}>
        <path d="m12 19-7-7 7-7" />
        <path d="M19 12H5" />
    </svg>
);

export const IconArrowRight = (p) => (
    <svg {...base} {...p}>
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
);

export const IconLock = (p) => (
    <svg {...base} {...p}>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);

export const IconMapPin = (p) => (
    <svg {...base} {...p}>
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

export const IconSparkles = (p) => (
    <svg {...base} {...p}>
        <path d="M9.94 14.06A2 2 0 0 0 8.5 12.6l-4.6-1.2a.5.5 0 0 1 0-.96l4.6-1.18A2 2 0 0 0 9.94 7.8l1.18-4.6a.5.5 0 0 1 .96 0l1.18 4.6a2 2 0 0 0 1.44 1.46l4.6 1.18a.5.5 0 0 1 0 .96l-4.6 1.2a2 2 0 0 0-1.44 1.46l-1.18 4.6a.5.5 0 0 1-.96 0z" />
        <path d="M19 4v3" />
        <path d="M20.5 5.5h-3" />
    </svg>
);

export const IconUserCheck = (p) => (
    <svg {...base} {...p}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <polyline points="16 11 18 13 22 9" />
    </svg>
);

export const IconSunrise = (p) => (
    <svg {...base} {...p}>
        <path d="M12 2v8" />
        <path d="m4.93 10.93 1.41 1.41" />
        <path d="M2 18h2" />
        <path d="M20 18h2" />
        <path d="m19.07 10.93-1.41 1.41" />
        <path d="M22 22H2" />
        <path d="m8 6 4-4 4 4" />
        <path d="M16 18a4 4 0 0 0-8 0" />
    </svg>
);

export const IconSunset = (p) => (
    <svg {...base} {...p}>
        <path d="M12 10V2" />
        <path d="m4.93 10.93 1.41 1.41" />
        <path d="M2 18h2" />
        <path d="M20 18h2" />
        <path d="m19.07 10.93-1.41 1.41" />
        <path d="M22 22H2" />
        <path d="m16 6-4 4-4-4" />
        <path d="M16 18a4 4 0 0 0-8 0" />
    </svg>
);

export const IconCalendar = (p) => (
    <svg {...base} {...p}>
        <path d="M8 2v4" />
        <path d="M16 2v4" />
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M3 10h18" />
        <path d="M8 14h.01" />
        <path d="M12 14h.01" />
        <path d="M16 14h.01" />
    </svg>
);

export const IconSliders = (p) => (
    <svg {...base} {...p}>
        <line x1="21" x2="14" y1="4" y2="4" />
        <line x1="10" x2="3" y1="4" y2="4" />
        <line x1="21" x2="12" y1="12" y2="12" />
        <line x1="8" x2="3" y1="12" y2="12" />
        <line x1="21" x2="16" y1="20" y2="20" />
        <line x1="12" x2="3" y1="20" y2="20" />
        <line x1="14" x2="14" y1="2" y2="6" />
        <line x1="8" x2="8" y1="10" y2="14" />
        <line x1="16" x2="16" y1="18" y2="22" />
    </svg>
);

export const IconEye = (p) => (
    <svg {...base} {...p}>
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

export const IconSmile = (p) => (
    <svg {...base} {...p}>
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <line x1="9" x2="9.01" y1="9" y2="9" />
        <line x1="15" x2="15.01" y1="9" y2="9" />
    </svg>
);

// Beard (facial hair) — cheeks line + jaw contour + mustache
export const IconBeard = (p) => (
    <svg {...base} {...p}>
        <path d="M5 8c1.6 1 3.8 1.5 7 1.5S17.4 9 19 8" />
        <path d="M5 8c0 6 2.6 11 7 11s7-5 7-11" />
        <path d="M9.3 11.4c.8.6 1.7.9 2.7.9s1.9-.3 2.7-.9" />
    </svg>
);

// Eyebrow — brow arc over an eye
export const IconEyebrow = (p) => (
    <svg {...base} {...p}>
        <path d="M3 9c3-3 15-3 18 0" />
        <path d="M4.5 15c2.3-2.8 12.7-2.8 15 0" />
        <path d="M4.5 15c2.3 2.8 12.7 2.8 15 0" />
        <circle cx="12" cy="15" r="1.7" />
    </svg>
);

export const IconCheck = (p) => (
    <svg {...base} {...p}>
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export const IconCheckCircle = (p) => (
    <svg {...base} {...p}>
        <path d="M21.8 10A10 10 0 1 1 17 3.34" />
        <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
);

export const IconTag = (p) => (
    <svg {...base} {...p}>
        <path d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.42l8.83 8.83a2 2 0 0 0 2.83 0l7.17-7.17a2 2 0 0 0 0-2.83z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
);

export const IconUser = (p) => (
    <svg {...base} {...p}>
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

export const IconBell = (p) => (
    <svg {...base} {...p}>
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </svg>
);

export const IconMail = (p) => (
    <svg {...base} {...p}>
        <rect width="20" height="16" x="2" y="4" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
);

export const IconPhone = (p) => (
    <svg {...base} {...p}>
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
);

// WhatsApp glyph (brand). Sized to fill its own viewBox.
export const IconWhatsApp = (p) => (
    <svg viewBox="0 0 448 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...p}>
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l119.7-31.4c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-156.9zM223.9 438.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-71 18.6 19-69.2-4.4-7.1c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
    </svg>
);
